<div class="report-fields-wrapper">
    @for (title of formattedFields.keys(); track $index) {
        <div class="report-fields-column">
            <h3 class="field-title">{{ title }}</h3>
            <div class="fields">
                @for (reportField of formattedFields.get(title); track reportField.id) {
                    <app-checkbox
                        [label]="reportField.displayName"
                        type="checkbox"
                        [groupId]="groupId"
                        [state]="selectedFields.has(reportField.id)"
                        (stateChange)="onStateChange(reportField)"
                    />
                }
            </div>
        </div>
    }
</div>
